<template>
  <div class="multiple-action-button">
    <div class="btn-wrapper btn-primary" @click="$emit('main-action')">
      <button
        type="button"
        id="setup-next"
      >
        <slot></slot>
      </button>

      <div class="arrow-wrapper">
        <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.5 0.5L5 6.5L0.5 0.5" stroke="white" stroke-linecap="round"/>
        </svg>
      </div>
    </div>

    <ul class="dropdown-menu disable-ske">
      <li v-for="item in options" :key="item.id" @click="item.action">
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    options: Array,
  },
}

</script>

<style scoped>

.multiple-action-button {
  position: relative;
}

.btn-wrapper {
  padding: 0px !important;
  display: flex;
  border-radius: 2px !important;
  cursor: pointer;
}

.arrow-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid white;
  width: 35px;
}

button {
  padding: 12px !important;
}

.dropdown-menu {
  right: 0px;
  left: unset;
  top: 100%;
  display: block !important;
  opacity: 1;
  visibility: visible !important;
  padding-bottom: 4px;
  padding-top: 4px;
  border-radius: 1px;
  max-height: 470px;
  white-space: nowrap;
  width: auto;
  min-width: auto;
  position: absolute;
  opacity: 0 !important;
  visibility: hidden !important;
  transition-duration: .15s;
}

.multiple-action-button:hover .dropdown-menu {
  opacity: 1 !important;
  visibility: visible !important;
}

li {
  padding: 8px;
  cursor: pointer;
}

li:hover {
  background-color: #f2f2f2;
}

</style>
